let paymentInputFilter = {
  id: {
      name: 'id',
      value: '',
      type: 'number',
      placeholder: 'transaction ID'
  },
  accounts: {
      name: 'accounts',
      type: 'select',
      value: '',
      selected: null,
      items: []
  },
  product: {
      name: 'products',
      type: 'select',
      value: '',
      selected: null,
      items: []
  },
  paymentTypes: {
      name: 'paymentTypes',
      type: 'select',
      value: '',
      selected: null,
      items: [
        {label: 'LINK', id: 1, data: {type: 'LINK'}},
        {label: 'POS', id: 2, data: {type: 'POS'}},
        {label: 'REFUND_IBAN', id: 3, data: {type: 'REFUND_IBAN'}}
      ]
  },
  amountFrom:{
      name: 'amountFrom',
      type: 'number',
      value: '',
      placeholder: 'from ...'
  },
  amountTo:{
      name: 'amountTo',
      type: 'number',
      value: '',
      placeholder: 'to...'
  },
  currency: {
      name: 'currencies',
      value: '',
      type: 'select',
      selected: null,
      items: []
  },
  status: {
      name: 'transactionStatuses',
      value: '',
      type: 'select',
      selected: null,
      items: []
  },
  maskedPan: {
      name: 'maskedPan',
      value: '',
      type: 'text',
      placeholder: 'masked pan'
  },
  paymentReference:{
      name: 'paymentReference',
      value: '',
      type: 'text',
      placeholder: 'payment reference'
  },
  rrn: {
      name: 'rrn',
      value: '',
      type: 'text',
      placeholder: 'rrn'
  },
  traceId: {
      name: 'traceId',
      value: '',
      type: 'text',
      placeholder: 'trace ID'
  },
  reference: {
      name: 'reference',
      value: '',
      type: 'text',
      placeholder: 'reference'
  },
  primaryContact: {
      name: 'primaryContact',
      value: '',
      type: 'text',
      placeholder: 'name'
  },
  email: {
      name: 'email',
      value: '',
      type: 'text',
      placeholder: 'Email'
  },
  mobile: {
      name: 'mobile',
      value: '',
      type: 'text',
      placeholder: 'mobile'
  },
  validityTo: {
    name: 'validityTo',
    value: null,
    type: 'text',
    isDate: true
  },
  validityFrom: {
    name: 'validityFrom',
    value: null,
    type: 'text',
    isDate: true
  },
  createdDateFrom: {
    name: 'createdDateFrom',
    value: null,
    type: 'text',
    isDate: true
  },
  createdDateTo: {
    name: 'createdDateTo',
    value: null,
    type: 'text',
    isDate: true
  },
  createdUser: {
    name: 'createdUsers',
    value: '',
    type: 'select',
    selected: null
  },
  createdOffice: {
    name: 'createdOffices',
    value: '',
    type: 'select',
    selected: null
  },
  approvedUsers: {
    name: 'approvedUsers',
    value: '',
    type: 'select',
    selected: null
  },
  txnDateFrom: {
    name: 'txnDateFrom',
    value: null,
    type: 'text',
    isDate: true
  },
  txnDateTo: {
    name: 'txnDateTo',
    value: null,
    type: 'text',
    isDate: true
  },
  autoAmount: {
    name: 'autoAmount',
    value: '',
    type: 'text'
  },
  autoBooking: {
    name: 'autoBooking',
    value: '',
    type: 'text'
  },
  purchaseId: {
    name: 'purchaseId',
    value: '',
    type: 'text'
  },
  page:0,
  rowsPerPage:10,
  totalCounts:-1,
  sortField: '',
  direction: ''
}


const defaultInputs = {
    id: {
        name: 'id',
        value: '',
        type: 'number',
        placeholder: 'transaction ID'
    },
    accounts: {
        name: 'accounts',
        type: 'select',
        value: '',
        selected: null,
        items: []
    },
    product: {
        name: 'products',
        type: 'select',
        value: '',
        selected: null,
        items: []
    },
    paymentTypes: {
      name: 'paymentTypes',
      type: 'select',
      value: '',
      selected: null,
      items: [
        {label: 'LINK', id: 1, data: {type: 'LINK'}},
        {label: 'POS', id: 2, data: {type: 'POS'}},
        {label: 'REFUND_IBAN', id: 3, data: {type: 'REFUND_IBAN'}}
      ]
    },
    amountFrom:{
        name: 'amountFrom',
        type: 'number',
        value: '',
        placeholder: 'from ...'
    },
    amountTo:{
        name: 'amountTo',
        type: 'number',
        value: '',
        placeholder: 'to...'
    },
    currency: {
        name: 'currencies',
        value: '',
        type: 'select',
        selected: null,
        items: []
    },
    status: {
        name: 'transactionStatuses',
        value: '',
        type: 'select',
        selected: null,
        items: []
    },
    maskedPan: {
        name: 'maskedPan',
        value: '',
        type: 'text',
        placeholder: 'masked pan'
    },
    paymentReference:{
        name: 'paymentReference',
        value: '',
        type: 'text',
        placeholder: 'payment reference'
    },
    rrn: {
        name: 'rrn',
        value: '',
        type: 'text',
        placeholder: 'rrn'
    },
    traceId: {
        name: 'trace ID',
        value: '',
        type: 'text',
        placeholder: 'trace ID'
    },
    reference: {
        name: 'reference',
        value: '',
        type: 'text',
        placeholder: 'reference'
    },
    primaryContact: {
        name: 'primaryContact',
        value: '',
        type: 'text',
        placeholder: 'name'
    },
    email: {
        name: 'email',
        value: '',
        type: 'text',
        placeholder: 'Email'
    },
    mobile: {
        name: 'mobile',
        value: '',
        type: 'text',
        placeholder: 'mobile'
    },
    validityTo: {
      name: 'validityTo',
      value: null,
      type: 'text',
      isDate: true
    },
    validityFrom: {
      name: 'validityFrom',
      value: null,
      type: 'text',
      isDate: true
    },
    createdDateTo: {
      name: 'createdDateTo',
      value: null,
      type: 'text',
      isDate: true
    },
    createdDateFrom: {
      name: 'createdDateFrom',
      value: null,
      type: 'text',
      isDate: true
    },
    createdUser: {
        name: 'createdUsers',
        value: '',
        type: 'select',
        selected: null
    },
    createdOffice: {
        name: 'createdOffices',
        value: '',
        type: 'select',
        selected: null
    },
    approvedUsers: {
      name: 'approvedUsers',
      value: '',
      type: 'select',
      selected: null
    },
    txnDateFrom: {
        name: 'txnDateFrom',
        value: null,
        type: 'text',
        isDate: true
    },
    txnDateTo: {
        name: 'txnDateTo',
        value: null,
        type: 'text',
        isDate: true
    },
    autoAmount: {
      name: 'autoAmount',
      value: '',
      type: 'text'
    },
    autoBooking: {
      name: 'autoBooking',
      value: '',
      type: 'text'
    },
    purchaseId: {
      name: 'purchaseId',
      value: '',
      type: 'text'
    },
    page:0,
    rowsPerPage:10,
    totalCounts:-1,
    sortField: '',
    direction: ''
  
}


const clearInputFields = () => {
    setPaymentInputFilter(defaultInputs)
}

const paymentInputFilterListeners = []
const setPaymentInputFilter = (input)=>{
  paymentInputFilter = {...input}
  for(let i=0; i< paymentInputFilterListeners.length; i++){
    paymentInputFilterListeners[i](paymentInputFilter)
  }
}
const getPaymentInputFilter = ()=>{
  return paymentInputFilter
}

const addListenerPaymentInputFilter = (fn) =>{
  paymentInputFilterListeners.push(fn) 
}



//======================= office inputFields ===================



let officeInputFilter = {
    name: {
      name: "name",
      value: "",
      type: "text",
      placeholder: "office name",
    },
    code: {
      name: "code",
      value: "",
      type: "text",
      placeholder: "Office Code ...",
    },
    email: {
      name: "email",
      value: "",
      type: "text",
      placeholder: "agency@example.com",
    },
    phone: {
      name: "phone",
      value: "",
      type: "text",
      placeholder: "(+237) 696 88 77 55",
    },
    accounting: {
      name: "accounting",
      value: "",
      type: "number",
      placeholder: "10001",
    },
    iata: {
      name: "iata",
      value: "",
      type: "text",
      placeholder: "THR",
    },
    contactPerson: {
      name: "contactPerson",
      value: "",
      type: "text",
      placeholder: "Manager name ...",
    },
    mobile: {
      name: "mobile",
      value: "",
      type: "text",
      placeholder: "0912 *** ** **",
    },
    city: {
      name: "city",
      value: "",
      type: "select",
      selected: null,
      items: [],
      icon: <i className="icon-Star-1"></i>,
    },
    address: {
      name: "address",
      value: "",
      type: "text",
      placeholder: "Street, Avenue, Alley, Plaque",
    },
    currency: {
      name: "currency",
      value: "",
      type: "select",
      items: [],
      selected: null
    },
    economicCode: {
      name: "economicCode",
      value: "",
      type: "text",
      placeholder: 'economic code'
    },
    page: 0,
    totalCounts: -1,
    rowsPerPage:10
}


const officeDefaultValue = {
    name: {
      name: "name",
      value: "",
      type: "text",
      placeholder: "office name",
    },
    code: {
      name: "code",
      value: "",
      type: "text",
      placeholder: "Office Code ...",
    },
    email: {
      name: "email",
      value: "",
      type: "text",
      placeholder: "agency@example.com",
    },
    phone: {
      name: "phone",
      value: "",
      type: "text",
      placeholder: "(+237) 696 88 77 55",
    },
    accounting: {
      name: "accounting",
      value: "",
      type: "number",
      placeholder: "10001",
    },
    iata: {
      name: "iata",
      value: "",
      type: "text",
      placeholder: "THR",
    },
    contactPerson: {
      name: "contactPerson",
      value: "",
      type: "text",
      placeholder: "Manager name ...",
    },
    mobile: {
      name: "mobile",
      value: "",
      type: "text",
      placeholder: "0912 *** ** **",
    },
    city: {
      name: "city",
      value: "",
      type: "select",
      selected: null,
      items: [],
      icon: <i className="icon-Star-1"></i>,
    },
    address: {
      name: "address",
      value: "",
      type: "text",
      placeholder: "Street, Avenue, Alley, Plaque",
    },
    currency: {
      name: "currency",
      value: "",
      type: "select",
      items: [],
      selected: null
    },
    economicCode: {
      name: "economicCode",
      value: "",
      type: "text",
      placeholder: 'economic code'
    },
    page: 0,
    totalCounts: -1,
    rowsPerPage:10
}

const officeInputFilterListeners = []

const clearOfficeInputfilter = () => {
    setOfficeInputFilter(officeDefaultValue)
}


const setOfficeInputFilter = (input)=>{
    officeInputFilter = {...input}
    for(let i=0; i< officeInputFilterListeners.length; i++){
        officeInputFilterListeners[i](officeInputFilter)
    }
}

const getOfficeInputFilter = () => {
    return officeInputFilter
}


const addListenerOfficeInputFilter = (fn) =>{
    officeInputFilterListeners.push(fn) 
  }



//=======================user inputFields==============


let userInputFields = {
  username: {
    name: 'username',
    value: '',
    type: 'text',
    placeholder: 'username'
},
name: {
    name: 'name',
    type: 'text',
    value: '',
    placeholder: 'name'
},
mobile: {
    name: 'mobile',
    type: 'text',
    value: '',
    placeholder: 'mobile'
},
email: {
    name: 'email',
    type: 'text',
    value: '',
    placeholder: 'email'
},
status: {
    name: 'status',
    type: 'select',
    value: null,
    selected: null,
    items: []
},
roles: {
    name: 'roles',
    type: 'select',
    value: '',
    selected: null,
    items: []
},
offices: {
    name: 'offices',
    type: 'select',
    value: null,
    selected:null,
    items:[]
},
page: 0,
totalCounts: -1,
rowsPerPage:10,
}


const defaultUserInputFields = {...userInputFields}

const userInputFilterListeners = []

const clearUserInputfilter = () => {
  setUserInputFilter(defaultUserInputFields)
}

const setUserInputFilter = (input)=>{
  userInputFields = {...input}
  for(let i=0; i< userInputFilterListeners.length; i++){
      userInputFilterListeners[i](userInputFields)
  }
}

const getUserInputFilter = () => {
  return userInputFields
}


const addListenerUserInputFilter = (fn) =>{
  userInputFilterListeners.push(fn) 
}





//======================= Roles inputFields ===============

let roleInputFilter = {
  status: {
    name: 'status',
    type: 'select',
    value: '',
    selected: null,
    items: []
  },
  privileges: {
    name: 'privileges',
    type: 'select',
    value: [],
    selected: null,
    items: []
  },
  name: {
    name: 'name',
    type: 'text',
    value: '',
    placeholder: 'Role name ...'
  },
  page: 0,
  totalCounts: -1,
  rowsPerPage:10
}

const roleDefaultInputFilter = {...roleInputFilter}

const roleInputFilterListeners = []

const clearRoleInputfilter = () => {
  setRoleInputFilter(roleDefaultInputFilter)
}

const setRoleInputFilter = (input)=>{
  roleInputFilter = {...input}
  for(let i=0; i< roleInputFilterListeners.length; i++){
      roleInputFilterListeners[i](roleInputFilter)
  }
}
const getRoleInputFilter = () => {
  return roleInputFilter
}

const addListenerRoleInputFilter = (fn) =>{
  roleInputFilterListeners.push(fn) 
}





//======================= isLoggedIn ===========================
let isLoggedIn = window.localStorage.getItem('token') ? true : false
let isLoggedInListeners = []

const setIsLoggedIn = (il) => {
    isLoggedIn = il
    for(let i=0; i< isLoggedInListeners.length; i++){
        isLoggedInListeners[i](isLoggedIn)
      }
}
const getIsLoggedIn = (il) => {
   return isLoggedIn
}
const addListenerIsLoggedIn = (il) => {
    isLoggedInListeners.push(il)
}

const ex = {
  setPaymentInputFilter,
  getPaymentInputFilter,
  addListenerPaymentInputFilter,
  setIsLoggedIn,
  getIsLoggedIn,
  addListenerIsLoggedIn,
  clearInputFields,
  setOfficeInputFilter,
  getOfficeInputFilter,
  addListenerOfficeInputFilter,
  clearOfficeInputfilter,
  clearUserInputfilter,
  setUserInputFilter,
  getUserInputFilter,
  addListenerUserInputFilter,
  clearRoleInputfilter,
  setRoleInputFilter,
  getRoleInputFilter,
  addListenerRoleInputFilter
}

export default ex 